import {
	CurrencyCodeEnum,
	DiscountStateEnum,
	DisplayType,
	LegView,
	PassengerLegStatusEnum,
	PaymentFormEnum,
	PaymentStateEnum,
	TripTypeEnum,
} from '../lib/heyapi.gen';

export const oneLeg: LegView = {
	legId: 'cea2113c-c8ab-43b5-a65a-43e9e732301d',
	legStatus: PassengerLegStatusEnum.BOOKED,
	startDateTime: '2024-09-12T12:25:18.034Z',
	startDateTimeWindowStart: '2024-09-12T12:25:18.034Z',
	startDateTimeWindowEnd: '2024-09-12T12:40:18.034Z',
	startDateTimeFix: false,
	endDateTime: '2024-09-12T13:03:20.034Z',
	endDateTimeWindowStart: '2024-09-12T12:25:18.034Z',
	endDateTimeWindowEnd: '2024-09-12T13:03:20.034Z',
	endDateTimeFix: false,
	cancellationFreeUntil: '2024-09-12T11:25:18.034Z',
	costOfCancellation: 1500,
	duration: 2282.0,
	distance: 6751.5,
	mode: TripTypeEnum.LBODTFLEX,
	modeOrigin: 'CAR',
	route: '',
	agencyName: 'Vetter',
	from: {
		name: 'Saale-Center, Rennbahnring 9, 06124 Halle (Saale), Deutschland',
		lng: '11.941506',
		lat: '51.480104',
		arrival: '2024-09-12T12:25:18.034Z',
		departure: '2024-09-12T12:25:18.034Z',
		locationType: DisplayType.ADDRESS,
	},
	to: {
		name: '06116, Halle (Saale), Sachsen-Anhalt, Deutschland',
		lng: '12.030904',
		lat: '51.476498',
		arrival: '2024-09-12T13:03:20.034Z',
		departure: '2024-09-12T13:03:20.034Z',
		locationType: DisplayType.ADDRESS,
	},
	payment: {
		paymentAmount: 1761,
		currencyCode: CurrencyCodeEnum.EUR,
		paymentForm: PaymentFormEnum.DIGITAL,
		paymentState: PaymentStateEnum.TO_PAY,
		paymentInformationAvailable: true,
	},
	intermediateStops: [],
	pricings: [
		{
			paymentHandlerCompanyName: 'MoPla Solutions GmbH',
			paymentHandlerCompanyType: 'MOPLA',
			paymentInformationAvailable: true,
			amount: 1761,
			currency: CurrencyCodeEnum.EUR,
			discount: DiscountStateEnum.NO_DISCOUNT,
			pricePerPassenger: 1761,
			deploymentPrice: 0,
		},
		{
			paymentHandlerCompanyName: 'MoPla Solutions GmbH',
			paymentHandlerCompanyType: 'MOPLA',
			paymentInformationAvailable: true,
			amount: 3537,
			currency: CurrencyCodeEnum.EUR,
			discount: DiscountStateEnum.PERSONAL_DISCOUNT_AVAILABLE,
			pricePerPassenger: 3537,
			deploymentPrice: 0,
		},
		{
			paymentHandlerCompanyName: 'MoPla Solutions GmbH',
			paymentHandlerCompanyType: 'MOPLA',
			paymentInformationAvailable: true,
			amount: 5313,
			currency: CurrencyCodeEnum.EUR,
			discount: DiscountStateEnum.NON_DISCOUNTED_TICKET_PRESENT,
			pricePerPassenger: 5313,
			deploymentPrice: 0,
		},
		{
			paymentHandlerCompanyName: 'MoPla Solutions GmbH',
			paymentHandlerCompanyType: 'MOPLA',
			paymentInformationAvailable: true,
			amount: 7019,
			currency: CurrencyCodeEnum.EUR,
			discount: DiscountStateEnum.DISCOUNTED_TICKET_PRESENT,
			pricePerPassenger: 7019,
			deploymentPrice: 0,
		},
	],
	paymentOptions: [PaymentFormEnum.DIGITAL],
	cancellationRules: [
		{
			secondsBeforeRideStart: 3600,
			currency: CurrencyCodeEnum.EUR,
			discount: DiscountStateEnum.NO_DISCOUNT,
			cost: 0,
		},
		{
			secondsBeforeRideStart: 0,
			currency: CurrencyCodeEnum.EUR,
			discount: DiscountStateEnum.NO_DISCOUNT,
			cost: 1761,
		},
	],
	lbodtflexLabel: 'AnrufbusFlex',
	timeInfo: {
		start: {
			startTime: '2025-05-08T10:53:02.564803Z',
			startTimeWindow: {
				start: '2025-05-08T10:53:02.564803Z',
				end: '2025-05-08T11:08:02.564803Z',
			},
			overwrittenStartTimeWindow: {
				start: '2025-05-08T11:30:02.564Z',
				end: '2025-05-08T11:45:02.564Z',
			},
			currentlyPredictedStartTime: undefined,
		},
		end: {
			endTime: '2025-05-08T13:15:06.564Z',
			endTimeWindow: {
				start: '2025-05-08T10:53:02.564803Z',
				end: '2025-05-08T12:38:06.564803Z',
			},
			overwrittenEndTimeWindow: {
				start: '2025-05-08T11:30:02.564Z',
				end: '2025-05-08T13:15:06.564Z',
			},
			currentlyPredictedEndTime: undefined,
		},
		includedPlannedDelayInMinutes: 0,
		startAndEndTimeFixed: false,
	},
};

export const oneLegOverwrittenTime: LegView[] = [
	{
		legId: 'f0ef0c3b-f618-4105-8f74-f345627c2ff9',
		startDateTime: '2025-05-08T10:53:02.564Z',
		startDateTimeWindowStart: '2025-05-08T10:53:02.564802738Z',
		startDateTimeWindowEnd: '2025-05-08T11:08:02.564802738Z',
		overwrittenStartTimeWindowStart: '2025-05-08T11:30:02.564Z',
		overwrittenStartTimeWindowEnd: '2025-05-08T11:45:02.564Z',
		startDateTimeFix: false,
		endDateTime: '2025-05-08T12:38:06.564Z',
		endDateTimeWindowStart: '2025-05-08T10:53:02.564802738Z',
		endDateTimeWindowEnd: '2025-05-08T12:38:06.564802738Z',
		overwrittenEndTimeWindowStart: '2025-05-08T11:30:02.564Z',
		overwrittenEndTimeWindowEnd: '2025-05-08T13:15:06.564Z',
		endDateTimeFix: false,
		legStatus: PassengerLegStatusEnum.BOOKED,
		costOfCancellation: 10200,
		duration: 6304.0,
		distance: 39996.8,
		mode: TripTypeEnum.LBODTFLEX,
		modeOrigin: 'CAR',
		route: '',
		// headsign: null,
		// routeId: null,
		// agencyId: null,
		agencyName: 'Vetter',
		distributorContactEmail: 'larson@mopla.solutions',
		isBlacklisted: false,
		// tripShortName: null,
		// tripId: null,
		from: {
			name: 'Aken (Elbe), Sachsen-Anhalt, Deutschland',
			// stopId: null,
			lng: '12.044637',
			lat: '51.855333',
			arrival: '2025-05-08T10:53:02.564Z',
			departure: '2025-05-08T10:53:02.564Z',
			locationType: DisplayType.ADDRESS,
			// stopDescription: null,
			// stopLink: null,
			// address: null,
		},
		to: {
			name: 'Bitterfeld-Wolfen, Sachsen-Anhalt, Deutschland',
			// stopId: null,
			lng: '12.328808',
			lat: '51.623215',
			arrival: '2025-05-08T12:38:06.564Z',
			departure: '2025-05-08T12:38:06.564Z',
			locationType: DisplayType.STOP,
			// stopDescription: null,
			// stopLink: null,
			// address: null,
		},
		// legGeometry: null,
		interlineWithPreviousLeg: false,
		payment: {
			paymentAmount: 34000,
			currencyCode: CurrencyCodeEnum.EUR,
			paymentForm: PaymentFormEnum.DIGITAL,
			paymentState: PaymentStateEnum.TO_PAY,
			// overwrittenPaymentAmount: null,
			paymentInformationAvailable: true,
		},
		bulkyLuggage: {
			costPerUnit: 0,
			maxCountPerRide: 1,
			orderedCount: 0,
		},
		paymentOptions: [
			PaymentFormEnum.DIGITAL,
			PaymentFormEnum.CASH,
			PaymentFormEnum.CARD,
		],
		intermediateStops: [],
		pricings: [
			{
				paymentHandlerCompanyName: 'MoPla Solutions GmbH',
				paymentHandlerCompanyType: 'MOPLA',
				amount: 10200,
				currency: CurrencyCodeEnum.EUR,
				discount: DiscountStateEnum.DISCOUNTED_TICKET_PRESENT,
				paymentInformationAvailable: true,
				pricePerPassenger: 10200,
				deploymentPrice: 0,
			},
			{
				paymentHandlerCompanyName: 'MoPla Solutions GmbH',
				paymentHandlerCompanyType: 'MOPLA',
				amount: 17000,
				currency: CurrencyCodeEnum.EUR,
				discount: DiscountStateEnum.NON_DISCOUNTED_TICKET_PRESENT,
				paymentInformationAvailable: true,
				pricePerPassenger: 17000,
				deploymentPrice: 0,
			},
			{
				paymentHandlerCompanyName: 'MoPla Solutions GmbH',
				paymentHandlerCompanyType: 'MOPLA',
				amount: 17000,
				currency: CurrencyCodeEnum.EUR,
				discount: DiscountStateEnum.PERSONAL_DISCOUNT_AVAILABLE,
				paymentInformationAvailable: true,
				pricePerPassenger: 17000,
				deploymentPrice: 0,
			},
			{
				paymentHandlerCompanyName: 'MoPla Solutions GmbH',
				paymentHandlerCompanyType: 'MOPLA',
				amount: 34000,
				currency: CurrencyCodeEnum.EUR,
				discount: DiscountStateEnum.NO_DISCOUNT,
				paymentInformationAvailable: true,
				pricePerPassenger: 34000,
				deploymentPrice: 0,
			},
		],
		cancellationRules: [
			{
				secondsBeforeRideStart: 1,
				currency: CurrencyCodeEnum.EUR,
				discount: DiscountStateEnum.NO_DISCOUNT,
				cost: 34000,
			},
		],
		lbodtflexLabel: 'AnrufbusFlex',
		zoneId: '2bb0a2bb-423f-47a9-82d8-67fa49e6cf23',
		timeInfo: {
			start: {
				startTime: '2025-05-08T10:53:02.564803Z',
				startTimeWindow: {
					start: '2025-05-08T10:53:02.564803Z',
					end: '2025-05-08T11:08:02.564803Z',
				},
				overwrittenStartTimeWindow: {
					start: '2025-05-08T11:30:02.564Z',
					end: '2025-05-08T11:45:02.564Z',
				},
				currentlyPredictedStartTime: '2025-05-08T11:30:02.564Z',
			},
			end: {
				endTime: '2025-05-08T10:53:02.564803Z',
				endTimeWindow: {
					start: '2025-05-08T10:53:02.564803Z',
					end: '2025-05-08T12:38:06.564803Z',
				},
				overwrittenEndTimeWindow: {
					start: '2025-05-08T11:30:02.564Z',
					end: '2025-05-08T13:15:06.564Z',
				},
				currentlyPredictedEndTime: '2025-05-08T13:15:06.564Z',
			},
			includedPlannedDelayInMinutes: 0,
			startAndEndTimeFixed: false,
		},
	},
];

export const multipleLegs: LegView[] = [
	{
		legId: 'cea2113c-c8ab-43b5-a65a-43e9e732301d',
		legStatus: PassengerLegStatusEnum.BOOKED,
		startDateTime: '2024-09-12T12:25:18.034Z',
		startDateTimeWindowStart: '2024-09-12T12:25:18.034Z',
		startDateTimeWindowEnd: '2024-09-12T12:40:18.034Z',
		startDateTimeFix: false,
		endDateTime: '2024-09-12T13:03:20.034Z',
		endDateTimeWindowStart: '2024-09-12T12:25:18.034Z',
		endDateTimeWindowEnd: '2024-09-12T13:03:20.034Z',
		endDateTimeFix: false,
		cancellationFreeUntil: '2024-09-12T11:25:18.034Z',
		costOfCancellation: 1761,
		duration: 2282.0,
		distance: 6751.5,
		mode: TripTypeEnum.LBODTFLEX,
		modeOrigin: 'CAR',
		route: '',
		from: {
			name: 'Saale-Center, Rennbahnring 9, 06124 Halle (Saale), Deutschland',
			lng: '11.941506',
			lat: '51.480104',
			arrival: '2024-09-12T12:25:18.034Z',
			departure: '2024-09-12T12:25:18.034Z',
			locationType: DisplayType.ADDRESS,
		},
		to: {
			name: '06116, Halle (Saale), Sachsen-Anhalt, Deutschland',
			lng: '12.030904',
			lat: '51.476498',
			arrival: '2024-09-12T13:03:20.034Z',
			departure: '2024-09-12T13:03:20.034Z',
			locationType: DisplayType.ADDRESS,
		},
		payment: {
			paymentAmount: 1761,
			currencyCode: CurrencyCodeEnum.EUR,
			paymentForm: PaymentFormEnum.DIGITAL,
			paymentState: PaymentStateEnum.TO_PAY,
			paymentInformationAvailable: true,
		},
		paymentOptions: [PaymentFormEnum.DIGITAL],
		intermediateStops: [],
		pricings: [
			{
				paymentHandlerCompanyName: 'MoPla Solutions GmbH',
				paymentHandlerCompanyType: 'MOPLA',
				paymentInformationAvailable: true,
				amount: 1761,
				currency: CurrencyCodeEnum.EUR,
				discount: DiscountStateEnum.NO_DISCOUNT,
				pricePerPassenger: 1761,
				deploymentPrice: 0,
			},
			{
				paymentHandlerCompanyName: 'MoPla Solutions GmbH',
				paymentHandlerCompanyType: 'MOPLA',
				paymentInformationAvailable: true,
				amount: 3537,
				currency: CurrencyCodeEnum.EUR,
				discount: DiscountStateEnum.PERSONAL_DISCOUNT_AVAILABLE,
				pricePerPassenger: 3537,
				deploymentPrice: 0,
			},
			{
				paymentHandlerCompanyName: 'MoPla Solutions GmbH',
				paymentHandlerCompanyType: 'MOPLA',
				paymentInformationAvailable: true,
				amount: 5313,
				currency: CurrencyCodeEnum.EUR,
				discount: DiscountStateEnum.NON_DISCOUNTED_TICKET_PRESENT,
				pricePerPassenger: 5313,
				deploymentPrice: 0,
			},
			{
				paymentHandlerCompanyName: 'MoPla Solutions GmbH',
				paymentHandlerCompanyType: 'MOPLA',
				paymentInformationAvailable: true,
				amount: 7019,
				currency: CurrencyCodeEnum.EUR,
				discount: DiscountStateEnum.DISCOUNTED_TICKET_PRESENT,
				pricePerPassenger: 7019,
				deploymentPrice: 0,
			},
		],
		cancellationRules: [
			{
				secondsBeforeRideStart: 3600,
				currency: CurrencyCodeEnum.EUR,
				discount: DiscountStateEnum.NO_DISCOUNT,
				cost: 0,
			},
			{
				secondsBeforeRideStart: 0,
				currency: CurrencyCodeEnum.EUR,
				discount: DiscountStateEnum.NO_DISCOUNT,
				cost: 1761,
			},
		],
		lbodtflexLabel: 'AnrufbusFlex',
		timeInfo: {
			start: {
				startTime: '2025-05-08T10:53:02.564803Z',
				startTimeWindow: {
					start: '2025-05-08T10:53:02.564803Z',
					end: '2025-05-08T11:08:02.564803Z',
				},
				overwrittenStartTimeWindow: {
					start: '2025-05-08T11:30:02.564Z',
					end: '2025-05-08T11:45:02.564Z',
				},
				currentlyPredictedStartTime: undefined,
			},
			end: {
				endTime: '2025-05-08T13:15:06.564Z',
				endTimeWindow: {
					start: '2025-05-08T10:53:02.564803Z',
					end: '2025-05-08T12:38:06.564803Z',
				},
				overwrittenEndTimeWindow: {
					start: '2025-05-08T11:30:02.564Z',
					end: '2025-05-08T13:15:06.564Z',
				},
				currentlyPredictedEndTime: undefined,
			},
			includedPlannedDelayInMinutes: 0,
			startAndEndTimeFixed: false,
		},
	},
	{
		legId: '6db7f367-9d81-4c9c-868c-1fba9f2a9aea',
		legStatus: PassengerLegStatusEnum.BOOKED,
		startDateTime: '2024-09-09T13:50:44.141Z',
		startDateTimeWindowStart: '2024-09-09T13:50:44.141Z',
		startDateTimeWindowEnd: '2024-09-09T14:05:44.141Z',
		overwrittenStartTimeWindowStart: '2024-09-09T12:00:44.141Z',
		overwrittenStartTimeWindowEnd: '2024-09-09T12:15:44.141Z',
		startDateTimeFix: false,
		endDateTime: '2024-09-09T14:21:14.141Z',
		endDateTimeWindowStart: '2024-09-09T13:50:44.141Z',
		endDateTimeWindowEnd: '2024-09-09T14:21:14.141Z',
		overwrittenEndTimeWindowStart: '2024-09-09T12:00:44.141Z',
		overwrittenEndTimeWindowEnd: '2024-09-09T12:31:14.141Z',
		endDateTimeFix: false,
		cancellationFreeUntil: '2024-09-09T12:50:44.141Z',
		costOfCancellation: 900,
		duration: 1830.0,
		distance: 4729.5,
		mode: TripTypeEnum.LBODTFLEX,
		modeOrigin: 'CAR',
		route: '',
		agencyName: 'Vetter',
		from: {
			name: 'Halle (Saale), Sachsen-Anhalt, Deutschland',
			lng: '11.974929',
			lat: '51.482197',
			arrival: '2024-09-09T13:50:44.141Z',
			departure: '2024-09-09T13:50:44.141Z',
			locationType: DisplayType.ADDRESS,
		},
		to: {
			name: '06116, Halle (Saale), Sachsen-Anhalt, Deutschland',
			lng: '12.030904',
			lat: '51.476498',
			arrival: '2024-09-09T14:21:14.141Z',
			departure: '2024-09-09T14:21:14.141Z',
			locationType: DisplayType.ADDRESS,
		},
		payment: {
			paymentAmount: 900,
			currencyCode: CurrencyCodeEnum.EUR,
			paymentForm: PaymentFormEnum.DIGITAL,
			paymentState: PaymentStateEnum.TO_PAY,
			paymentInformationAvailable: true,
		},
		paymentOptions: [PaymentFormEnum.DIGITAL],
		intermediateStops: [],
		pricings: [
			{
				paymentHandlerCompanyName: 'MoPla Solutions GmbH',
				paymentHandlerCompanyType: 'MOPLA',
				paymentInformationAvailable: true,
				amount: 900,
				currency: CurrencyCodeEnum.EUR,
				discount: DiscountStateEnum.NO_DISCOUNT,
				pricePerPassenger: 900,
				deploymentPrice: 0,
			},
			{
				paymentHandlerCompanyName: 'MoPla Solutions GmbH',
				paymentHandlerCompanyType: 'MOPLA',
				paymentInformationAvailable: true,
				amount: 1900,
				currency: CurrencyCodeEnum.EUR,
				discount: DiscountStateEnum.NON_DISCOUNTED_TICKET_PRESENT,
				pricePerPassenger: 1900,
				deploymentPrice: 0,
			},
			{
				paymentHandlerCompanyName: 'MoPla Solutions GmbH',
				paymentHandlerCompanyType: 'MOPLA',
				paymentInformationAvailable: true,
				amount: 2900,
				currency: CurrencyCodeEnum.EUR,
				discount: DiscountStateEnum.PERSONAL_DISCOUNT_AVAILABLE,
				pricePerPassenger: 2900,
				deploymentPrice: 0,
			},
			{
				paymentHandlerCompanyName: 'MoPla Solutions GmbH',
				paymentHandlerCompanyType: 'MOPLA',
				paymentInformationAvailable: true,
				amount: 3900,
				currency: CurrencyCodeEnum.EUR,
				discount: DiscountStateEnum.DISCOUNTED_TICKET_PRESENT,
				pricePerPassenger: 3900,
				deploymentPrice: 0,
			},
		],
		cancellationRules: [
			{
				secondsBeforeRideStart: 3600,
				currency: CurrencyCodeEnum.EUR,
				discount: DiscountStateEnum.NO_DISCOUNT,
				cost: 0,
			},
			{
				secondsBeforeRideStart: 0,
				currency: CurrencyCodeEnum.EUR,
				discount: DiscountStateEnum.NO_DISCOUNT,
				cost: 900,
			},
		],
		lbodtflexLabel: 'AnrufbusFlex',
		timeInfo: {
			start: {
				startTime: '2025-05-08T10:53:02.564803Z',
				startTimeWindow: {
					start: '2025-05-08T10:53:02.564803Z',
					end: '2025-05-08T11:08:02.564803Z',
				},
				overwrittenStartTimeWindow: {
					start: '2025-05-08T11:30:02.564Z',
					end: '2025-05-08T11:45:02.564Z',
				},
				currentlyPredictedStartTime: undefined,
			},
			end: {
				endTime: '2025-05-08T13:15:06.564Z',
				endTimeWindow: {
					start: '2025-05-08T10:53:02.564803Z',
					end: '2025-05-08T12:38:06.564803Z',
				},
				overwrittenEndTimeWindow: {
					start: '2025-05-08T11:30:02.564Z',
					end: '2025-05-08T13:15:06.564Z',
				},
				currentlyPredictedEndTime: undefined,
			},
			includedPlannedDelayInMinutes: 0,
			startAndEndTimeFixed: false,
		},
	},
	{
		legId: '8ffe6114-c24a-4fc1-bea6-11bde39aa459',
		legStatus: PassengerLegStatusEnum.BOOKED,
		startDateTime: '2024-09-09T13:10:28Z',
		startDateTimeWindowStart: '2024-09-09T13:08:58Z',
		startDateTimeWindowEnd: '2024-09-09T13:08:58Z',
		startDateTimeFix: true,
		endDateTime: '2024-09-09T13:17:32Z',
		endDateTimeWindowStart: '2024-09-09T13:16:48Z',
		endDateTimeWindowEnd: '2024-09-09T13:16:48Z',
		endDateTimeFix: true,
		duration: 470.0,
		distance: 4729.5,
		mode: TripTypeEnum.PRODT,
		modeOrigin: '',
		route: '',
		agencyName: 'Vetter',
		from: {
			name: 'Hansering 11, 06108 Halle (Saale), Deutschland',
			lng: '11.97494',
			lat: '51.4822',
			arrival: '2024-09-09T13:08:58Z',
			departure: '2024-09-09T13:08:58Z',
			locationType: DisplayType.ADDRESS,
		},
		to: {
			name: 'Käthe-Kollwitz-Straße 21, 06116 Halle (Saale), Deutschland',
			lng: '12.0309',
			lat: '51.4765',
			arrival: '2024-09-09T13:16:48Z',
			departure: '2024-09-09T13:16:48Z',
			locationType: DisplayType.ADDRESS,
		},
		payment: {
			paymentAmount: 105,
			currencyCode: CurrencyCodeEnum.EUR,
			paymentForm: PaymentFormEnum.DIGITAL,
			paymentState: PaymentStateEnum.PAID,
			paymentInformationAvailable: true,
		},
		paymentOptions: [PaymentFormEnum.DIGITAL],

		intermediateStops: [],
		pricings: [
			{
				paymentHandlerCompanyName: 'MoPla Solutions GmbH',
				paymentHandlerCompanyType: 'MOPLA',
				paymentInformationAvailable: true,
				amount: 105,
				currency: CurrencyCodeEnum.EUR,
				discount: DiscountStateEnum.NO_DISCOUNT,
				pricePerPassenger: 105,
				deploymentPrice: 0,
			},
		],
		cancellationRules: [
			{
				secondsBeforeRideStart: 0,
				currency: CurrencyCodeEnum.EUR,
				discount: DiscountStateEnum.NO_DISCOUNT,
				cost: 105,
			},
			{
				secondsBeforeRideStart: 5400,
				currency: CurrencyCodeEnum.EUR,
				discount: DiscountStateEnum.NO_DISCOUNT,
				cost: 32,
			},
		],
		costOfCancellation: 123,
		timeInfo: {
			start: {
				startTime: '2025-05-08T10:53:02.564803Z',
				startTimeWindow: {
					start: '2025-05-08T10:53:02.564803Z',
					end: '2025-05-08T11:08:02.564803Z',
				},
				overwrittenStartTimeWindow: {
					start: '2025-05-08T11:30:02.564Z',
					end: '2025-05-08T11:45:02.564Z',
				},
				currentlyPredictedStartTime: undefined,
			},
			end: {
				endTime: '2025-05-08T13:15:06.564Z',
				endTimeWindow: {
					start: '2025-05-08T10:53:02.564803Z',
					end: '2025-05-08T12:38:06.564803Z',
				},
				overwrittenEndTimeWindow: {
					start: '2025-05-08T11:30:02.564Z',
					end: '2025-05-08T13:15:06.564Z',
				},
				currentlyPredictedEndTime: undefined,
			},
			includedPlannedDelayInMinutes: 0,
			startAndEndTimeFixed: false,
		},
	},
];

export const multipleLegsWithOverwrittenTime: LegView[] = [
	{
		legId: 'cea2113c-c8ab-43b5-a65a-43e9e732301d',
		legStatus: PassengerLegStatusEnum.BOOKED,
		startDateTime: '2024-09-12T12:25:18.034Z',
		startDateTimeWindowStart: '2024-09-12T12:25:18.034Z',
		startDateTimeWindowEnd: '2024-09-12T12:40:18.034Z',
		startDateTimeFix: false,
		endDateTime: '2024-09-12T13:03:20.034Z',
		endDateTimeWindowStart: '2024-09-12T12:25:18.034Z',
		endDateTimeWindowEnd: '2024-09-12T13:03:20.034Z',
		endDateTimeFix: false,
		cancellationFreeUntil: '2024-09-12T11:25:18.034Z',
		costOfCancellation: 1761,
		duration: 2282.0,
		distance: 6751.5,
		mode: TripTypeEnum.LBODTFLEX,
		modeOrigin: 'CAR',
		route: '',
		from: {
			name: 'Saale-Center, Rennbahnring 9, 06124 Halle (Saale), Deutschland',
			lng: '11.941506',
			lat: '51.480104',
			arrival: '2024-09-12T12:25:18.034Z',
			departure: '2024-09-12T12:25:18.034Z',
			locationType: DisplayType.ADDRESS,
		},
		to: {
			name: '06116, Halle (Saale), Sachsen-Anhalt, Deutschland',
			lng: '12.030904',
			lat: '51.476498',
			arrival: '2024-09-12T13:03:20.034Z',
			departure: '2024-09-12T13:03:20.034Z',
			locationType: DisplayType.ADDRESS,
		},
		payment: {
			paymentAmount: 1761,
			currencyCode: CurrencyCodeEnum.EUR,
			paymentForm: PaymentFormEnum.DIGITAL,
			paymentState: PaymentStateEnum.TO_PAY,
			paymentInformationAvailable: true,
		},
		paymentOptions: [PaymentFormEnum.DIGITAL],
		intermediateStops: [],
		pricings: [
			{
				paymentHandlerCompanyName: 'MoPla Solutions GmbH',
				paymentHandlerCompanyType: 'MOPLA',
				paymentInformationAvailable: true,
				amount: 1761,
				currency: CurrencyCodeEnum.EUR,
				discount: DiscountStateEnum.NO_DISCOUNT,
				pricePerPassenger: 1761,
				deploymentPrice: 0,
			},
			{
				paymentHandlerCompanyName: 'MoPla Solutions GmbH',
				paymentHandlerCompanyType: 'MOPLA',
				paymentInformationAvailable: true,
				amount: 3537,
				currency: CurrencyCodeEnum.EUR,
				discount: DiscountStateEnum.PERSONAL_DISCOUNT_AVAILABLE,
				pricePerPassenger: 3537,
				deploymentPrice: 0,
			},
			{
				paymentHandlerCompanyName: 'MoPla Solutions GmbH',
				paymentHandlerCompanyType: 'MOPLA',
				paymentInformationAvailable: true,
				amount: 5313,
				currency: CurrencyCodeEnum.EUR,
				discount: DiscountStateEnum.NON_DISCOUNTED_TICKET_PRESENT,
				pricePerPassenger: 5313,
				deploymentPrice: 0,
			},
			{
				paymentHandlerCompanyName: 'MoPla Solutions GmbH',
				paymentHandlerCompanyType: 'MOPLA',
				paymentInformationAvailable: true,
				amount: 7019,
				currency: CurrencyCodeEnum.EUR,
				discount: DiscountStateEnum.DISCOUNTED_TICKET_PRESENT,
				pricePerPassenger: 7019,
				deploymentPrice: 0,
			},
		],
		cancellationRules: [
			{
				secondsBeforeRideStart: 3600,
				currency: CurrencyCodeEnum.EUR,
				discount: DiscountStateEnum.NO_DISCOUNT,
				cost: 0,
			},
			{
				secondsBeforeRideStart: 0,
				currency: CurrencyCodeEnum.EUR,
				discount: DiscountStateEnum.NO_DISCOUNT,
				cost: 1761,
			},
		],
		lbodtflexLabel: 'AnrufbusFlex',
		timeInfo: {
			start: {
				startTime: '2025-05-08T10:53:02.564803Z',
				startTimeWindow: {
					start: '2025-05-08T10:53:02.564803Z',
					end: '2025-05-08T11:08:02.564803Z',
				},
				overwrittenStartTimeWindow: {
					start: '2025-05-08T11:30:02.564Z',
					end: '2025-05-08T11:45:02.564Z',
				},
				currentlyPredictedStartTime: undefined,
			},
			end: {
				endTime: '2025-05-08T13:15:06.564Z',
				endTimeWindow: {
					start: '2025-05-08T10:53:02.564803Z',
					end: '2025-05-08T12:38:06.564803Z',
				},
				overwrittenEndTimeWindow: {
					start: '2025-05-08T11:30:02.564Z',
					end: '2025-05-08T13:15:06.564Z',
				},
				currentlyPredictedEndTime: undefined,
			},
			includedPlannedDelayInMinutes: 0,
			startAndEndTimeFixed: false,
		},
	},
	{
		legId: 'f0ef0c3b-f618-4105-8f74-f345627c2ff9',
		startDateTime: '2025-05-08T10:53:02.564Z',
		startDateTimeWindowStart: '2025-05-08T10:53:02.564802738Z',
		startDateTimeWindowEnd: '2025-05-08T11:08:02.564802738Z',
		overwrittenStartTimeWindowStart: '2025-05-08T11:30:02.564Z',
		overwrittenStartTimeWindowEnd: '2025-05-08T11:45:02.564Z',
		startDateTimeFix: false,
		endDateTime: '2025-05-08T12:38:06.564Z',
		endDateTimeWindowStart: '2025-05-08T10:53:02.564802738Z',
		endDateTimeWindowEnd: '2025-05-08T12:38:06.564802738Z',
		overwrittenEndTimeWindowStart: '2025-05-08T11:30:02.564Z',
		overwrittenEndTimeWindowEnd: '2025-05-08T13:15:06.564Z',
		endDateTimeFix: false,
		legStatus: PassengerLegStatusEnum.BOOKED,
		costOfCancellation: 10200,
		duration: 6304.0,
		distance: 39996.8,
		mode: TripTypeEnum.LBODTFLEX,
		modeOrigin: 'CAR',
		route: '',
		// headsign: null,
		// routeId: null,
		// agencyId: null,
		agencyName: 'Vetter',
		distributorContactEmail: 'larson@mopla.solutions',
		isBlacklisted: false,
		// tripShortName: null,
		// tripId: null,
		from: {
			name: 'Aken (Elbe), Sachsen-Anhalt, Deutschland',
			// stopId: null,
			lng: '12.044637',
			lat: '51.855333',
			arrival: '2025-05-08T10:53:02.564Z',
			departure: '2025-05-08T10:53:02.564Z',
			locationType: DisplayType.ADDRESS,
			// stopDescription: null,
			// stopLink: null,
			// address: null,
		},
		to: {
			name: 'Bitterfeld-Wolfen, Sachsen-Anhalt, Deutschland',
			// stopId: null,
			lng: '12.328808',
			lat: '51.623215',
			arrival: '2025-05-08T12:38:06.564Z',
			departure: '2025-05-08T12:38:06.564Z',
			locationType: DisplayType.STOP,
			// stopDescription: null,
			// stopLink: null,
			// address: null,
		},
		// legGeometry: null,
		interlineWithPreviousLeg: false,
		payment: {
			paymentAmount: 34000,
			currencyCode: CurrencyCodeEnum.EUR,
			paymentForm: PaymentFormEnum.DIGITAL,
			paymentState: PaymentStateEnum.TO_PAY,
			// overwrittenPaymentAmount: null,
			paymentInformationAvailable: true,
		},
		bulkyLuggage: {
			costPerUnit: 0,
			maxCountPerRide: 1,
			orderedCount: 0,
		},
		paymentOptions: [
			PaymentFormEnum.DIGITAL,
			PaymentFormEnum.CASH,
			PaymentFormEnum.CARD,
		],
		intermediateStops: [],
		pricings: [
			{
				paymentHandlerCompanyName: 'MoPla Solutions GmbH',
				paymentHandlerCompanyType: 'MOPLA',
				amount: 10200,
				currency: CurrencyCodeEnum.EUR,
				discount: DiscountStateEnum.DISCOUNTED_TICKET_PRESENT,
				paymentInformationAvailable: true,
				pricePerPassenger: 10200,
				deploymentPrice: 0,
			},
			{
				paymentHandlerCompanyName: 'MoPla Solutions GmbH',
				paymentHandlerCompanyType: 'MOPLA',
				amount: 17000,
				currency: CurrencyCodeEnum.EUR,
				discount: DiscountStateEnum.NON_DISCOUNTED_TICKET_PRESENT,
				paymentInformationAvailable: true,
				pricePerPassenger: 17000,
				deploymentPrice: 0,
			},
			{
				paymentHandlerCompanyName: 'MoPla Solutions GmbH',
				paymentHandlerCompanyType: 'MOPLA',
				amount: 17000,
				currency: CurrencyCodeEnum.EUR,
				discount: DiscountStateEnum.PERSONAL_DISCOUNT_AVAILABLE,
				paymentInformationAvailable: true,
				pricePerPassenger: 17000,
				deploymentPrice: 0,
			},
			{
				paymentHandlerCompanyName: 'MoPla Solutions GmbH',
				paymentHandlerCompanyType: 'MOPLA',
				amount: 34000,
				currency: CurrencyCodeEnum.EUR,
				discount: DiscountStateEnum.NO_DISCOUNT,
				paymentInformationAvailable: true,
				pricePerPassenger: 34000,
				deploymentPrice: 0,
			},
		],
		cancellationRules: [
			{
				secondsBeforeRideStart: 1,
				currency: CurrencyCodeEnum.EUR,
				discount: DiscountStateEnum.NO_DISCOUNT,
				cost: 34000,
			},
		],
		lbodtflexLabel: 'AnrufbusFlex',
		zoneId: '2bb0a2bb-423f-47a9-82d8-67fa49e6cf23',
		timeInfo: {
			start: {
				startTime: '2025-05-08T10:53:02.564803Z',
				startTimeWindow: {
					start: '2025-05-08T10:53:02.564803Z',
					end: '2025-05-08T11:08:02.564803Z',
				},
				overwrittenStartTimeWindow: {
					start: '2025-05-08T11:30:02.564Z',
					end: '2025-05-08T11:45:02.564Z',
				},
				currentlyPredictedStartTime: '2025-05-08T11:30:02.564Z',
			},
			end: {
				endTime: '2025-05-08T10:53:02.564803Z',
				endTimeWindow: {
					start: '2025-05-08T10:53:02.564803Z',
					end: '2025-05-08T12:38:06.564803Z',
				},
				overwrittenEndTimeWindow: {
					start: '2025-05-08T11:30:02.564Z',
					end: '2025-05-08T13:15:06.564Z',
				},
				currentlyPredictedEndTime: '2025-05-08T13:15:06.564Z',
			},
			includedPlannedDelayInMinutes: 0,
			startAndEndTimeFixed: false,
		},
	},
	{
		legId: '8ffe6114-c24a-4fc1-bea6-11bde39aa459',
		legStatus: PassengerLegStatusEnum.BOOKED,
		startDateTime: '2024-09-09T13:10:28Z',
		startDateTimeWindowStart: '2024-09-09T13:08:58Z',
		startDateTimeWindowEnd: '2024-09-09T13:08:58Z',
		startDateTimeFix: true,
		endDateTime: '2024-09-09T13:17:32Z',
		endDateTimeWindowStart: '2024-09-09T13:16:48Z',
		endDateTimeWindowEnd: '2024-09-09T13:16:48Z',
		endDateTimeFix: true,
		duration: 470.0,
		distance: 4729.5,
		mode: TripTypeEnum.PRODT,
		modeOrigin: '',
		route: '',
		agencyName: 'Vetter',
		from: {
			name: 'Hansering 11, 06108 Halle (Saale), Deutschland',
			lng: '11.97494',
			lat: '51.4822',
			arrival: '2024-09-09T13:08:58Z',
			departure: '2024-09-09T13:08:58Z',
			locationType: DisplayType.ADDRESS,
		},
		to: {
			name: 'Käthe-Kollwitz-Straße 21, 06116 Halle (Saale), Deutschland',
			lng: '12.0309',
			lat: '51.4765',
			arrival: '2024-09-09T13:16:48Z',
			departure: '2024-09-09T13:16:48Z',
			locationType: DisplayType.ADDRESS,
		},
		payment: {
			paymentAmount: 105,
			currencyCode: CurrencyCodeEnum.EUR,
			paymentForm: PaymentFormEnum.DIGITAL,
			paymentState: PaymentStateEnum.PAID,
			paymentInformationAvailable: true,
		},
		paymentOptions: [PaymentFormEnum.DIGITAL],

		intermediateStops: [],
		pricings: [
			{
				paymentHandlerCompanyName: 'MoPla Solutions GmbH',
				paymentHandlerCompanyType: 'MOPLA',
				paymentInformationAvailable: true,
				amount: 105,
				currency: CurrencyCodeEnum.EUR,
				discount: DiscountStateEnum.NO_DISCOUNT,
				pricePerPassenger: 105,
				deploymentPrice: 0,
			},
		],
		cancellationRules: [
			{
				secondsBeforeRideStart: 0,
				currency: CurrencyCodeEnum.EUR,
				discount: DiscountStateEnum.NO_DISCOUNT,
				cost: 105,
			},
			{
				secondsBeforeRideStart: 5400,
				currency: CurrencyCodeEnum.EUR,
				discount: DiscountStateEnum.NO_DISCOUNT,
				cost: 32,
			},
		],
		costOfCancellation: 123,
		timeInfo: {
			start: {
				startTime: '2025-05-08T10:53:02.564803Z',
				startTimeWindow: {
					start: '2025-05-08T10:53:02.564803Z',
					end: '2025-05-08T11:08:02.564803Z',
				},
				overwrittenStartTimeWindow: {
					start: '2025-05-08T11:30:02.564Z',
					end: '2025-05-08T11:45:02.564Z',
				},
				currentlyPredictedStartTime: undefined,
			},
			end: {
				endTime: '2025-05-08T13:15:06.564Z',
				endTimeWindow: {
					start: '2025-05-08T10:53:02.564803Z',
					end: '2025-05-08T12:38:06.564803Z',
				},
				overwrittenEndTimeWindow: {
					start: '2025-05-08T11:30:02.564Z',
					end: '2025-05-08T13:15:06.564Z',
				},
				currentlyPredictedEndTime: undefined,
			},
			includedPlannedDelayInMinutes: 0,
			startAndEndTimeFixed: false,
		},
	},
];
